import React from 'react';
import useLocale from '../../hooks/useLocale';
import { parseColor } from '../../theme/materialTheme';
import Flex from '../common/Flex';
import ImageBox from '../common/ImageBox';
import MuiCard from '../common/MuiCard';
import MuiText from '../intl/MuiText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const CategoryInterestCard = ({ category, selected }) => {
  const { locale } = useLocale();
  const { text, style } = makeProps({ category, selected, locale });
  return (
    <MuiCard {...style.card}>
      <Flex {...style.iconBox}>
        <CheckCircleIcon {...style.icon} />
      </Flex>
      <ImageBox {...style.image} />
      <MuiText {...text.name} />
    </MuiCard>
  );

  function makeProps({ category, selected, locale }) {
    const { image } = category || {};
    return {
      text: {
        name: {
          children: category[`${locale}Name`],
          lines: 2,
          forceAllLines: true,
          sx: { textAlign: 'center', m: '0.25rem', color: 'headingText.main' },
        },
      },
      style: {
        card: {
          sx: {
            position: 'relative',
            m: '0',
            p: '0',
            maxWidth: '100%',
            overflow: 'hidden',
            boxShadow: '0px 2px 8px rgb(0 0 0 / 16%)',
            outline: '2px solid',
            outlineColor: 'transparent',
            ...(selected && { outlineColor: parseColor('primary.main') }),
            transition: 'outline-color 200ms',
          },
        },
        iconBox: {
          sx: {
            position: 'absolute',
            zIndex: '1',
            top: '0.25rem',
            right: '0.25rem',
            opacity: '0',
            fontSize: '1.75rem',
            color: 'primary.main',
            borderRadius: '10rem',
            backgroundColor: 'card.main',
            ...(selected && { opacity: '1' }),
            transition: 'opacity 200ms',
          },
        },
        icon: { sx: { fontSize: 'inherit' } },
        image: { image, size: '100%', aspectRatio: 3 / 2 },
      },
    };
  }
};

export default CategoryInterestCard;
